import { Input } from 'antd';
import React, { ReactElement, forwardRef, useEffect, useState } from 'react';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

const { TextArea } = Input;

export const FormTextArea = forwardRef((props: any, ref: React.ForwardedRef<HTMLTextAreaElement>): ReactElement | null => {
  const formConfig = useGetFormConfig(props);
  const [extraRules, setExtraRules] = useState<any[]>([]);
  const {
    disabled,
    key,
    allowClear,
    onChange,
    onFocus,
    onBlur,
    className,
    contentEditable,
    minLengthValue,
    maxLengthValue,
    fieldLengthValue,
  } = formConfig;

  // Added validation rules based on min/max length values
  useEffect((): void => {
    const rules = [
      minLengthValue && fieldLengthValue?.[0] ? { min: fieldLengthValue[0] } : null,
      maxLengthValue && fieldLengthValue?.[1] ? { max: fieldLengthValue[1] } : null,
    ].filter(Boolean);

    setExtraRules(rules);
  }, [minLengthValue, maxLengthValue, fieldLengthValue]);

  const placeholder =
    props?.detail?.placeholder !== undefined
      ? props.detail.placeholder      // Dynamic placeholder from props
      : formConfig?.placeholder;      // Otherwise, fallback to formConfig placeholder
  return (
    <FormItem formConfig={formConfig} extraRules={extraRules}>
      <TextArea
        allowClear={allowClear}
        data-testid={key}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        contentEditable={contentEditable}
        ref={ref}
        autoComplete="off"
        onChange={onChange}
        onBlur={(): void => onBlur && onBlur()}
        onFocus={(): void => onFocus && onFocus()}
      />
    </FormItem>
  );
});

export default FormTextArea;
